export class ResponseAge {
    private _menos_de_18: number | undefined
    private _18_29: number | undefined
    private _30_39: number | undefined
    private _40_49: number | undefined
    private _50_59: number | undefined
    private _60_ou_mais: number | undefined

    // menos de 18
    public get menos_de_18(): number | undefined {
        return this._menos_de_18
    }
    public set menos_de_18(value: number | undefined) {
        this._menos_de_18 = value
    }

    // 18 a 29
    public get faixa_18_29(): number | undefined {
        return this._18_29
    }
    public set faixa_18_29(value: number | undefined) {
        this._18_29 = value
    }

    // 30 a 39
    public get faixa_30_39(): number | undefined {
        return this._30_39
    }
    public set faixa_30_39(value: number | undefined) {
        this._30_39 = value
    }

    // 40 a 49
    public get faixa_40_49(): number | undefined {
        return this._40_49
    }
    public set faixa_40_49(value: number | undefined) {
        this._40_49 = value
    }

    // 50 a 59
    public get faixa_50_59(): number | undefined {
        return this._50_59
    }
    public set faixa_50_59(value: number | undefined) {
        this._50_59 = value
    }

    // 60 ou mais
    public get faixa_60_ou_mais(): number | undefined {
        return this._60_ou_mais
    }
    public set faixa_60_ou_mais(value: number | undefined) {
        this._60_ou_mais = value
    }

    // popula a partir de JSON
    public fromJSON(json: any): ResponseAge {
        if (!json){
           return this
        } 

        if (typeof json === 'string') {
            try {
                json = JSON.parse(json)
            } catch {
                return this
            }
        }

        if (json.menos_de_18 !== undefined) {
            this._menos_de_18 = json.menos_de_18
        }
        if (json["18_29"] !== undefined) {
            this._18_29 = json["18_29"]
        }
        if (json["30_39"] !== undefined) {
            this._30_39 = json["30_39"]
        }
        if (json["40_49"] !== undefined) {
            this._40_49 = json["40_49"]
        }
        if (json["50_59"] !== undefined) {
            this._50_59 = json["50_59"]
        }
        if (json["60_ou_mais"] !== undefined) {
            this._60_ou_mais = json["60_ou_mais"]
        }

        return this
    }

    // exporta para JSON
    public toJSON(): any {
        return {
            menos_de_18: this._menos_de_18,
            "18_29": this._18_29,
            "30_39": this._30_39,
            "40_49": this._40_49,
            "50_59": this._50_59,
            "60_ou_mais": this._60_ou_mais,
        }
    }
}
